import $ from "jquery";
window.$ = window.jQuery = $;

import { createIcons, icons } from "lucide";
window.lucide = {
  icons,
  createIcons: (opts = {}) => createIcons({ icons, ...opts }),
};

// vendor css
import "@tabler/icons-webfont/dist/tabler-icons.css";

// import "./plugins/example.js";
import "../scss/main/default.scss";

// exms custom js
import "./plugins/popup.js";
import "./plugins/ui-notify.js";